import { Greeting } from '@/presentation/components/Greeting'
import { LastMonthRevenueCard } from './components/LastMonthRevenueCard'
import { MonthlyRevenueCard } from './components/MonthlyRevenueCard'
import { WeeklyEarningsChart } from './components/WeeklyEarningsChart'
import { useHomeViewModel } from './hooks/useHomeViewModel'

/**
 * 首页组件
 * 通过 useHomeViewModel 获取整合后的状态
 */
export default function Home() {
  const { greeting, revenueSummary, weeklyChart } = useHomeViewModel()

  return (
    <div
      className='relative flex w-full flex-col items-center bg-white px-5'
      data-testid='home-page'
    >
      <Greeting {...greeting} />

      <MonthlyRevenueCard amount={revenueSummary.monthlyAmount} />

      {revenueSummary.lastMonthCard.shouldShow && (
        <LastMonthRevenueCard
          displayAmount={revenueSummary.lastMonthCard.display}
          monthName={revenueSummary.lastMonthCard.monthName}
        />
      )}

      <WeeklyEarningsChart {...weeklyChart} />
    </div>
  )
}
